import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';

import { Button } from '@shared/components';

@Component({
  selector: 'app-mobile-demo',
  imports: [Button, NgOptimizedImage],
  templateUrl: './mobile-demo.html',
  styleUrl: './mobile-demo.scss',
})
export class MobileDemo {}
